import React from 'react';
import { Link } from 'react-router-dom';
import '../styling/PrivacyPolicy.css';

const PrivacyPolicy: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <div className="privacy-header">
        <div className="container">
          <h1 className="privacy-title">Travelisk Privacy Policy</h1>
          <p className="privacy-subtitle">
            Your privacy matters to us. Learn how we protect and handle your information.
          </p>
        </div>
      </div>

      <div className="container">
        <div className="privacy-content">
          <section className="privacy-section">
            <h2>1. Introduction</h2>
            <p>
              Welcome to Travelisk. We value your privacy and are committed to protecting your personal data. 
              This policy outlines how we handle the information collected through our Facebook Page and Lead Forms.
            </p>
          </section>

          <section className="privacy-section">
            <h2>2. Information We Collect</h2>
            <p>When you interact with our Lead Forms or contact us via Facebook, we may collect:</p>
            <ul>
              <li><strong>Contact Details:</strong> Name, email address, and phone number.</li>
              <li><strong>Travel Preferences:</strong> Destination interests, group size, and planned travel dates.</li>
              <li><strong>Technical Data:</strong> Information provided by Meta&apos;s lead generation tools.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>3. How We Use Your Information</h2>
            <p>We use the data collected specifically to:</p>
            <ul>
              <li>Provide you with the requested travel quotes and itineraries.</li>
              <li>Contact you via call, WhatsApp, or email regarding your inquiry.</li>
              <li>Improve our tour packages and customer service.</li>
              <li>We do not sell your personal data to third-party marketing companies.</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>4. Data Storage and Security</h2>
            <p>
              Your data is stored securely and is only accessible by our authorized booking team to process your travel 
              requests. We retain this information only as long as necessary to fulfill your booking or inquiry.
            </p>
          </section>

          <section className="privacy-section">
            <h2>5. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Request a copy of the data we have about you.</li>
              <li>Request that we delete your information from our database.</li>
              <li>Opt-out of any future marketing communications.</li>
            </ul>
          </section>

          <section className="privacy-section privacy-contact">
            <h2>6. Contact Us</h2>
            <p>For any questions regarding your privacy, please contact us at:</p>
            <ul className="contact-list">
              <li>
                <strong>Email:</strong>{' '}
                <a href="mailto:traveliskinfo@gmail.com">traveliskinfo@gmail.com</a>
              </li>
              <li>
                <strong>Phone/WhatsApp:</strong>{' '}
                <a href="https://wa.me/917002155057" target="_blank" rel="noopener noreferrer">
                  +917002155057
                </a>
              </li>
            </ul>
            <Link to="/contact" className="privacy-cta">Get in Touch</Link>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
